import { atom } from 'recoil';
import { recoilPersist } from 'recoil-persist';

const { persistAtom } = recoilPersist();

export interface Company {
   id: number;
   hash?: string;
   name: string;
   document?: string;
   type?: string;
   current_balance?: number;
   has_zoop_seller?: boolean;
   has_idez?: boolean;
   has_dual_providers?: boolean;
   provider_default?: 'zoop' | 'idez';
}

export function normalizeCompany(company: Partial<Company> & Pick<Company, 'id' | 'name'>): Company {
   const hasZoop = Boolean(company.has_zoop_seller);
   const hasIdez = Boolean(company.has_idez);

   return {
      id: company.id,
      hash: company.hash,
      name: company.name,
      document: company.document,
      type: company.type,
      current_balance: company.current_balance ?? 0,
      has_zoop_seller: hasZoop,
      has_idez: hasIdez,
      has_dual_providers: hasZoop && hasIdez,
      provider_default: company.provider_default === 'idez' ? 'idez' : 'zoop',
   };
}

export function companyHasDualProviders(company?: Company | null): boolean {
   if (!company) {
      return false;
   }

   return Boolean(company.has_zoop_seller && company.has_idez);
}

export function resolveDefaultPaymentProvider(company?: Company | null): 'zoop' | 'idez' {
   if (company?.has_idez && !company?.has_zoop_seller) {
      return 'idez';
   }

   return company?.provider_default === 'idez' ? 'idez' : 'zoop';
}

/** Company selecionada na página (filtro de listagens). */
export const companyPageSelectState = atom<Company | null>({
   key: '@xpag/company-page-select',
   default: null,
   effects_UNSTABLE: [persistAtom],
});

/** Company selecionada para ações (criação de pagamentos, etc.). */
export const companySelectState = atom<Company | null>({
   key: '@xpag/company-select',
   default: null,
   effects_UNSTABLE: [persistAtom],
});

/** Exibir informações da company nas listagens. */
export const companyShowInfoState = atom<boolean>({
   key: '@xpag/show-company-info',
   default: true,
   effects_UNSTABLE: [persistAtom],
});

/** Usuário com única company vinculada. */
export const uniqueCompanyUserState = atom<boolean>({
   key: '@xpag/unique-company-user',
   default: true,
   effects_UNSTABLE: [persistAtom],
});
